
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/pnpp-story",
      function () {
        return require("private-next-pages/stories/pnpp-story.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/pnpp-story"])
      });
    }
  